import React, { useState, useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    TranslatedString,
    InputField,
    Card,
    PrimaryButton,
    Form
} from '@bosch/bt-ui';

import './PanelIdLookupHelper.css';
import withErrorHandler from '../../../components/ErrorHandler';
import RadioOptions from '../../sim-activation-detail-page/RadioComponent/RadioOptions';
import RestfulCallLoading from '../../../components/RestfulCallLoading';

const getEnvConfig = () => {
    const url = SUPPORTCONSOLE_API_URL;
    const isDev = url.includes('dev');
    const isTest = url.includes('test');
    const isLocal = url.includes('localhost');

    if (isDev || isLocal) {
        return {
        envOptions: ['dev'],
        initialQueryEnv: 'dev',
        };
    }
    if (isTest) {
        return {
        envOptions: ['test'],
        initialQueryEnv: 'test',
        };
    }
    return {
        envOptions: ['prod', 'test', 'dev'],
        initialQueryEnv: 'prod',
    };
}

const PanelIdLookupHelper = (props) => {
    const {
        token,
        isLoggedIn,
        panelIdResult,
        panelIdStatus,
        getDeviceDomainMappings
    } = props;

    const { envOptions, initialQueryEnv } = useMemo(() => {
        return getEnvConfig();
    }, []);
    

    const [searchAnyDomainId, setSearchAnyDomainId] = useState('');
    const [queryEnv, setQueryEnv] = React.useState(initialQueryEnv); // prod, test, dev
    const navigate = useNavigate();

    const onFormSubmit = useCallback(
        () => {
            if (token?.token) {
                if(isLoggedIn()) {
                    getDeviceDomainMappings('GET', SUPPORTCONSOLE_API_URL + '/api/panelenvironment/v1/devicedomainmappings/' + encodeURIComponent(searchAnyDomainId) + '?queryEnv=' + encodeURIComponent(queryEnv), null, undefined, { 'Authorization': 'Bearer ' + token.token });
                }
                else {
                    navigate('/');
                }
            }
        },
        [searchAnyDomainId, queryEnv, token.token, getDeviceDomainMappings, isLoggedIn, navigate]
    );

    const idTypeMap = React.useMemo(() => {
        const data = panelIdResult?.data;
        if (!data) return {};
        return data.reduce((acc, item) => {
            acc[item.idType] = item.value;
            return acc;
        }, {});
    }, [panelIdResult?.data]);

    const panelIds = (result) => {
        const data = result?.data;
        if (data == null) {
            return <TranslatedString stringId="not-found"/>
        } else {
            return <>
                <div><TranslatedString stringId="cloud-id" />: {idTypeMap["CloudId"] ?? ""}</div>
                <div><TranslatedString stringId="physical-id" />: {idTypeMap["PhysicalPanelId"] ?? ""}</div>
                <div><TranslatedString stringId="pid" />: {idTypeMap["PanelProductId"] ?? ""}</div>
                <div><TranslatedString stringId="device-id" />: {idTypeMap["DeviceId"] ?? ""}</div>
            </>
        }
    }

    return (
        <Card
            htmlAttributes={{
                id: 'panel-id-lookup-helper',
            }}
        >
            <div className="caption font-large"><TranslatedString stringId="caption-panel-id-lookup-helper"/></div>
            <div className='panel-id-lookup-helper'>
                <div className='panel-id-lookup-helper-option'>
                    <Form
                        formAttributes={{
                            onSubmit: onFormSubmit,
                            method: 'get',
                            action: ''
                        }}
                    >
                        <div className="Input-field">
                            <TranslatedString stringId="enter-any-known-panel-id" />:
                            <InputField
                                inputType="text"
                                fieldName="panelId"
                                label="Panel ID"
                                htmlAttributes={{
                                    onChange: (update) => setSearchAnyDomainId(update.value),
                                    value: searchAnyDomainId
                                }}
                            />
                            <PrimaryButton
                                type="submit"
                                disabled={searchAnyDomainId.length == 0}
                            >
                                <TranslatedString stringId="button-search" />
                            </PrimaryButton>
                        </div>
                        
                        <div className='panel-radio-options'>
                            <TranslatedString stringId="search-in" />:
                            {envOptions.map(env => (
                                <RadioOptions
                                    key={env}
                                    label={env.toUpperCase()}
                                    value={queryEnv === env}
                                    onChange={() => setQueryEnv(env)}
                                />
                            ))}
                        </div>
                        <TranslatedString stringId="note-panel-id-lookup-helper" />   
                    </Form>
                </div>
                <div className='panel-id'>
                    <TranslatedString stringId="found" />:
                    { panelIdResult && <div>{panelIds(panelIdResult)}</div> }
                </div>
            </div>
            <RestfulCallLoading status={panelIdStatus} />
        </Card>
    );
};

export default withErrorHandler(React.memo(PanelIdLookupHelper));